/*
  COSNETIC -- Cloudflare Turnstile, site-wide (2026-09-22).

  Every <div class="cc-turnstile" data-sitekey="..."> on the page becomes a Turnstile widget. The
  widget has pre-clearance switched on in Cloudflare, so a solved widget also gives the browser a
  cf_clearance cookie -- which is what lets a human's POST /contact through the "managed challenge
  on contact-form posts" WAF rule without ever seeing a challenge page. Shopify's own form endpoint
  cannot verify a token, so the token itself is never posted; the clearance cookie does the work.

  data-gate="#formId"       submit button of that form stays disabled until the widget is solved
  data-appearance           "always" (visible box, the contact form) or "interaction-only" (footer:
                            invisible unless Cloudflare needs a click)
  data-wait="1"             on submit, wait up to 4 s for a token before letting the form go (footer
                            newsletter: never blocks a human, just gives the clearance time to land)
*/
(function () {
  if (window.ccTurnstileBoot) return;   // the snippet may be rendered twice on one page (form + footer)
  window.ccTurnstileBoot = true;
  var SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=ccTurnstileReady';
  var boxes = Array.prototype.slice.call(document.querySelectorAll('.cc-turnstile[data-sitekey]'));
  if (!boxes.length) return;

  function form(box) { var sel = box.getAttribute('data-gate'); return sel ? document.querySelector(sel) : box.closest('form'); }
  function submitOf(f) { return f ? f.querySelector('[type="submit"]') : null; }
  function note(box, on) { var n = box.parentElement && box.parentElement.querySelector('.cc-kc__captcha-note'); if (n) n.classList.toggle('is-on', !!on); }

  boxes.forEach(function (box) {
    box.ccToken = '';
    var f = form(box), b = submitOf(f);
    if (b && box.getAttribute('data-gate')) { b.disabled = true; b.setAttribute('data-cc-gated', '1'); }
    if (f && box.getAttribute('data-wait') === '1') {
      f.addEventListener('submit', function (e) {
        if (box.ccToken || !window.turnstile || f.ccWaited) return;
        e.preventDefault();
        var t0 = Date.now();
        (function tick() {
          if (box.ccToken || Date.now() - t0 > 4000) { f.ccWaited = true; f.requestSubmit ? f.requestSubmit() : f.submit(); return; }
          setTimeout(tick, 120);
        })();
      });
    }
  });

  // A widget rendered inside a hidden container (the contact form before a topic is picked) never sizes,
  // so hidden boxes wait; cc-contact.js dispatches 'cc:reveal' on document when the form unfolds.
  function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }
  document.addEventListener('cc:reveal', function () { if (window.turnstile) window.ccTurnstileReady(); });
  window.ccTurnstileReady = function () {
    boxes.forEach(function (box) {
      if (box.ccRendered || !visible(box)) return;
      box.ccRendered = true;
      var f = form(box), b = submitOf(f);
      try {
        window.turnstile.render(box, {
          sitekey: box.getAttribute('data-sitekey'),
          appearance: box.getAttribute('data-appearance') || 'always',
          theme: 'light',
          language: (document.documentElement.lang || 'auto').slice(0, 2),
          'refresh-expired': 'auto',
          callback: function (token) { box.ccToken = token; if (b && b.getAttribute('data-cc-gated')) b.disabled = false; note(box, false); },
          'expired-callback': function () { box.ccToken = ''; if (b && b.getAttribute('data-cc-gated')) b.disabled = true; },
          'error-callback': function () { box.ccToken = ''; note(box, true); }
        });
      } catch (err) { note(box, true); }
    });
  };

  var s = document.createElement('script');
  s.src = SRC; s.async = true; s.defer = true;
  s.onerror = function () { boxes.forEach(function (box) { note(box, true); }); };
  document.head.appendChild(s);
  // Blocked by a content blocker: the script never loads and never errors. Say so after 8 s.
  setTimeout(function () { if (!window.turnstile) boxes.forEach(function (box) { note(box, true); }); }, 8000);
})();
